
<template>
  <div>
    <div
      v-for="(value, norm) in availableNorms"
      :key="norm"
      class="caption-item"
    >
      <div
        class="colored-block"
        :class="norm"
      />
      <div style="word-break: break-word;">
        <div v-if="norm === 'veryLow'">
          <span>
            {{ `${$t('forms.labels.result')} &lt;
               ${availableNorms.veryLow }
                ${measureUnit}`
            }}

          </span>
        </div>
        <div v-if="norm === 'low'">
          <span>
            {{ `${availableNorms.veryLow} &leq;
                    ${$t('forms.labels.result')}
                    &lt; ${availableNorms.low}
                    ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'minimum'">
          <span>
            {{ `${availableNorms.low} &leq;
                ${$t('forms.labels.result')}
                    &lt; ${availableNorms.minimum}
                    ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'lastLevelMin'">
          <span>
            {{ `${availableNorms.lastLevelMin} &geq;
              ${$t('forms.labels.result')}
              ${measureUnit}` }}
          </span>
        </div>
        <div v-if="norm === 'maximum'">
          <span v-if="levelsNumber === 3">
            {{ `${availableNorms.maximum} &leq;
                  ${$t('forms.labels.result')}
                  ${measureUnit}`
            }}
          </span>
          <span v-if="levelsNumber === 6">
            {{ `${availableNorms.minimum} &leq;
                  ${$t('forms.labels.result')}
                  &lt; ${availableNorms.maximum }
                  ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'high'">
          <span>
            {{ `${availableNorms.maximum} &leq;
                    ${$t('forms.labels.result')}
                    &lt; ${availableNorms.high }
                    ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'veryHigh'">
          <span>
            {{ `${availableNorms.high} &leq;
            ${$t('forms.labels.result')}
            &lt; ${availableNorms.veryHigh}
            ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'lastLevel'">
          <span>
            {{ `${$t('forms.labels.result')} &geq;
              ${availableNorms.lastLevel}  ${measureUnit} `
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { has, cloneDeep } from 'lodash';


export default {
    props: {
        norms: {
            type: Object,
            default: () => {},
        },
        measureUnit: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            availableNorms: {},
        };
    },
    computed: {
        levelsNumber() {
            return Object.keys(this.norms).length;
        },
    },
    watch: {
        norms: {
            handler() {
                this.availableNorms = cloneDeep(this.norms);
                if (this.levelsNumber === 3) {
                    // Range level number = level number + 1
                    if (has(this.norms, 'minimum')) this.availableNorms.lastLevelMin = this.norms.minimum;
                    else if (has(this.norms, 'maximum')) this.availableNorms.lastLevel = this.norms.maximum;
                } else if (this.levelsNumber === 6) this.availableNorms.lastLevel = this.norms.veryHigh;
            },
            immediate: true,
            deep: true,
        },
    },
};

</script>

<style lang="scss" scoped>
.caption-title {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 16px;

  &::after {
    content: '';
    display: block;
    width: 30px;
    height: 2px;
    background-color: #DC582A;
  }
}

.standard-family-title {
  color: #aaa;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.standard-block {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  padding: 4px 7px;
  margin-bottom: 8px;
  &:last-of-type {
    border-bottom: 0;
  }
}

.caption-item {
  display: flex;
  align-items: center;
  padding: 1px 0;
  .colored-block {
    background: #eee;
    width: 35px;
    min-width: 35px;
    height: 35px;
    margin-right: 8px;
    &.minimum {
      background: #C7A21B;
    }
    &.maximum {
      background: #2A7113;
    }
    &.low {
      background: #FF9800;
    }
     &.high {
      background: #C7A21B;
    }
    &.veryHigh {
      background: #FF9800;
    }
    &.veryLow {
      background: #AD1C3F;
    }
    &.lastLevel {
      background: #AD1C3F;
    }
    &.lastLevelMin{
      background: #2A7113;
    }
  }
}
</style>
